module.exports = __webpack_public_path__ + "img/AnalysisScreenshot1.419084be.png";